import Swiper from "swiper";
import { Navigation, Pagination, EffectFade, FreeMode, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export function sliders(selector, properties) {

    const instance = new Swiper(selector, {
      modules: [Navigation, Pagination, EffectFade, FreeMode, Autoplay],
      ...properties,
    });

  return instance; // Return instances instead of DOM elements
}